import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorIntlBrService extends MatPaginatorIntl {
  itemsPerPageLabel = 'Itens por página:';
  nextPageLabel = 'Página seguinte';
  previousPageLabel = 'Página anterior';

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `Mostrando 0 de ${length} resultados`;
    }

    const startIndex = page * pageSize;

    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;

    return `Mostrando ${startIndex + 1} - ${endIndex} de ${length} resultados`;
  };
}
